import { render, staticRenderFns } from "./PolicyInquiryAllActivities.vue?vue&type=template&id=39db23b8"
import script from "./PolicyInquiryAllActivities.vue?vue&type=script&lang=ts"
export * from "./PolicyInquiryAllActivities.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports